import { func } from 'prop-types';
import Button from '@alltrails/shared/denali/components/Button';
import * as styles from './styles/styles.module.scss';
import BottomTray from '../../shared/BottomTray';
import { StringConstantsMixin } from 'react_components/mixins/shared/string_constants_mixin';

const {
  strings: {
    GIFT_FLOW: { CHOOSE_A_CHECKOUT_METHOD, CHECKOUT_AS_GUEST },
    SIGNUP: { LOGIN }
  }
} = StringConstantsMixin;

const GiftTray = ({ closeTray, navigateTo }) => {
  return (
    <BottomTray closeTray={closeTray}>
      <div className={styles.container}>
        <div className={styles.trayContent}>
          <div className={styles.spacer} />
          <div className={styles.buttonContainer}>
            <div className={styles.headline}>{CHOOSE_A_CHECKOUT_METHOD}</div>
            <div className={styles.loginButton}>
              <Button text={LOGIN} onClick={() => navigateTo('/gift/login')} testId="gift-tray-login" variant="primary" width="full" />
            </div>
            <Button
              text={CHECKOUT_AS_GUEST}
              onClick={() => navigateTo('/gift/payment')}
              testId="gift-tray-checkout-as-guest"
              variant="default"
              width="full"
            />
          </div>
        </div>
      </div>
    </BottomTray>
  );
};

GiftTray.propTypes = {
  closeTray: func.isRequired,
  navigateTo: func.isRequired
};

export default GiftTray;
